export default __webpack_public_path__ + "static/media/007.308ba18d.jpg";